import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadApplicationTheme = () => get(`${url}/user/theme`);

const exp = {
  loadApplicationTheme
};
export default exp;
